'use client';

import { BreakpointSwitch } from '@spikemark/ui/components/breakpoint-switch';
import { NavTabs, TabDatum } from '@spikemark/ui/components/nav-tabs';
import compact from 'lodash/compact';
import { FC } from 'react';
import { TournamentNavigation } from '../navigation';
type ScoringNavigationProps = {
  enableRelatedEvents?: boolean;
  enableStatistics?: boolean;
  feedEnabled?: boolean;
  hideTeeTimes?: boolean;
  matchPlay: boolean;
  participantsEnabled?: boolean;
  teamTournament: boolean;
  tournamentId: string;
};
type TabsProps = {
  basePath: string;
  enableRelatedEvents?: boolean;
  enableStatistics?: boolean;
  feedEnabled?: boolean;
  participantsEnabled?: boolean;
  teamTournament?: boolean;
  teeTimesEnabled?: boolean;
};
const StrokePlayTabs = ({
  basePath,
  enableRelatedEvents,
  enableStatistics,
  feedEnabled,
  participantsEnabled,
  teamTournament,
  teeTimesEnabled
}: TabsProps) => {
  const pages: TabDatum[] = compact([feedEnabled && {
    href: `${basePath}/feed`,
    title: 'Live Feed'
  }, participantsEnabled && {
    href: `${basePath}/participants`,
    title: 'Participants'
  }, teeTimesEnabled && {
    href: `${basePath}/tee-times`,
    title: 'Tee Times'
  }, teamTournament && {
    href: `${basePath}/team`,
    title: 'Team Leaderboard'
  }, {
    href: `${basePath}/player`,
    title: 'Player Leaderboard'
  }, enableStatistics && {
    href: `${basePath}/stats`,
    title: 'Stats'
  }, enableRelatedEvents && {
    href: `${basePath}/related-events`,
    title: 'Related Events'
  }]);
  const mobilePages: TabDatum[] = compact([feedEnabled && {
    href: `${basePath}/feed`,
    title: 'Live'
  }, participantsEnabled && {
    href: `${basePath}/participants`,
    title: 'Partic.'
  }, teeTimesEnabled && {
    href: `${basePath}/tee-times`,
    title: 'Times'
  }, teamTournament && {
    href: `${basePath}/team`,
    title: 'Team'
  }, {
    href: `${basePath}/player`,
    title: 'Player'
  }, enableStatistics && {
    href: `${basePath}/stats`,
    title: 'Stats'
  }, enableRelatedEvents && {
    href: `${basePath}/related-events`,
    title: 'Related'
  }]);
  return <BreakpointSwitch breakpoint="md" fallback={<NavTabs items={mobilePages} />} data-sentry-element="BreakpointSwitch" data-sentry-component="StrokePlayTabs" data-sentry-source-file="navigation.tsx">
      <NavTabs items={pages} data-sentry-element="NavTabs" data-sentry-source-file="navigation.tsx" />
    </BreakpointSwitch>;
};
const MatchPlayTabs = ({
  basePath,
  enableRelatedEvents,
  enableStatistics,
  feedEnabled,
  participantsEnabled,
  teeTimesEnabled
}: TabsProps) => {
  const pages: TabDatum[] = compact([feedEnabled && {
    href: `${basePath}/feed`,
    title: 'Live Feed'
  }, participantsEnabled && {
    href: `${basePath}/participants`,
    title: 'Participants'
  }, teeTimesEnabled && {
    href: `${basePath}/tee-times`,
    title: 'Tee Times'
  }, {
    href: `${basePath}/team`,
    title: 'Team Leaderboard'
  }, {
    href: `${basePath}/round`,
    title: 'Matches'
  }, enableStatistics && {
    href: `${basePath}/stats`,
    title: 'Stats'
  }, enableRelatedEvents && {
    href: `${basePath}/related-events`,
    title: 'Related Events'
  }]);
  const mobilePages: TabDatum[] = compact([feedEnabled && {
    href: `${basePath}/feed`,
    title: 'Live'
  }, participantsEnabled && {
    href: `${basePath}/participants`,
    title: 'Partic.'
  }, teeTimesEnabled && {
    href: `${basePath}/tee-times`,
    title: 'Times'
  }, {
    href: `${basePath}/team`,
    title: 'Team'
  }, {
    href: `${basePath}/round`,
    title: 'Matches'
  }, enableStatistics && {
    href: `${basePath}/stats`,
    title: 'Stats'
  }, enableRelatedEvents && {
    href: `${basePath}/related-events`,
    title: 'Related'
  }]);
  return <BreakpointSwitch breakpoint="md" fallback={<NavTabs items={mobilePages} />} data-sentry-element="BreakpointSwitch" data-sentry-component="MatchPlayTabs" data-sentry-source-file="navigation.tsx">
      <NavTabs items={pages} data-sentry-element="NavTabs" data-sentry-source-file="navigation.tsx" />
    </BreakpointSwitch>;
};
export const ScoringNavigation: FC<ScoringNavigationProps> = ({
  enableRelatedEvents,
  enableStatistics,
  feedEnabled,
  hideTeeTimes,
  matchPlay,
  participantsEnabled,
  teamTournament,
  tournamentId
}) => {
  const basePath = `/tournaments/${tournamentId}/scoring`;
  const Tabs = matchPlay ? MatchPlayTabs : StrokePlayTabs;
  return <TournamentNavigation data-sentry-element="TournamentNavigation" data-sentry-component="ScoringNavigation" data-sentry-source-file="navigation.tsx">
      <Tabs basePath={basePath} enableRelatedEvents={enableRelatedEvents} enableStatistics={enableStatistics} feedEnabled={feedEnabled} participantsEnabled={participantsEnabled} teamTournament={teamTournament} teeTimesEnabled={!hideTeeTimes} data-sentry-element="Tabs" data-sentry-source-file="navigation.tsx" />
    </TournamentNavigation>;
};